import React from "react";

import { useEventListener } from "./useEventListener";

export const useIsScrollable = (ref: React.MutableRefObject<HTMLElement | null>) => {
  const [ isScrollableLeft, setIsScrollableLeft ] = React.useState<boolean>(false);
  const [ isScrollableRight, setIsScrollableRight ] = React.useState<boolean>(false);

  useEventListener("scroll", () => {
    if (ref.current) {
      setIsScrollableRight(ref.current.scrollWidth > ref.current.scrollLeft + ref.current.clientWidth);
      setIsScrollableLeft(ref.current.scrollLeft > 0);
    }
  }, ref.current);

  React.useEffect(() => {
    const { current } = ref;

    const checkScrollability = () => {
      if (ref.current) {
        setIsScrollableRight(ref.current.scrollWidth > ref.current.scrollLeft + ref.current.clientWidth);
        setIsScrollableLeft((ref.current.scrollLeft > 0));
      }
    };

    if (current) {
      if ("ResizeObserver" in window) {
        new ResizeObserver(checkScrollability).observe(current);
      }

      checkScrollability();
    }
  }, [ ref ]);

  return {
    isScrollableLeft,
    isScrollableRight
  };
};
